import {
  BaseQueryFn,
  createApi,
  FetchArgs,
  fetchBaseQuery,
  FetchBaseQueryError,
} from '@reduxjs/toolkit/query/react'

import { AuthVerifyOtpResponse } from '../../types/AuthVerifyOtpResponse'
import { getNode } from '../../../common/utils/Sdk'

const node = getNode()
const baseUrl = node === 'PRODUCTION' ?
  'https://api.trunkrs.app/v2' : 'https://staging-api.trunkrs.app/v2'
const baseQuery = fetchBaseQuery({
  baseUrl,
  prepareHeaders: (headers) => {
    const token = localStorage.getItem('accessToken')

    if (token) {
      headers.set('Authorization', `Bearer ${token}`)
    }

    return headers
  },
})

const baseQueryWithReauth: BaseQueryFn<
  string | FetchArgs,
  unknown,
  FetchBaseQueryError
> = async (args, api, extraOptions) => {
  let result = await baseQuery(args, api, extraOptions)

  const refreshToken = localStorage.getItem('refreshToken')

  if (result.error && [401, 403, 'FETCH_ERROR'].includes(result.error.status)) {
    const refreshResult = await baseQuery(
      {
        url: '/auth/functions/refresh-credentials',
        method: 'POST',
        body: {
          refresh_token: refreshToken,
        },
      },
      api,
      extraOptions,
    )

    if (refreshResult.data) {
      const { AccessToken } = (refreshResult.data as AuthVerifyOtpResponse)
        .AuthenticationResult

      localStorage.setItem('accessToken', AccessToken)
    }

    // retry the initial query
    result = await baseQuery(args, api, extraOptions)
  }

  return result
}

export const api = createApi({
  reducerPath: 'api',
  baseQuery: baseQueryWithReauth,
  endpoints: () => ({}),
  tagTypes: ['MorningScanResult', 'ShipmentsForReturn'],
})
